import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Accordion } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import DrivedFieldAccordion from './DrivedFieldAccordion';
import css from '../styles.css';

function DrivedFieldsValues({ fields, fieldData }) {
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    fields.move(result.source.index, result.destination.index);
  };

  const renderDrivedFields = () => {
    return fields.map((name, index) => {
      const isDragDisabled = fields.length < 2;
      return (
        <Draggable
          key={name}
          draggableId={`drivedFields-${name}-${index}`}
          index={index}
          disableInteractiveElementBlocking
          isDragDisabled={isDragDisabled}
        >
          {(draggableProvided, snapshot) => {
            return (
              <DrivedFieldAccordion
                draggableProvided={draggableProvided}
                snapshot={snapshot}
                fieldIndex={index}
                fieldName={name}
                fields={fields}
                fieldData={fieldData}
              />
            );
          }}
        </Draggable>
      );
    });
  };

  return (
    <div>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="drived-fields-accordion-droppable">
          {(droppableProvided) => (
            <div
              ref={droppableProvided.innerRef}
              {...droppableProvided.droppableProps}
            >
              {fields.value?.length > 0 && (
                <Accordion
                  id={`${fieldData.name}-drivation-options-aacordion}`}
                  label={
                    <FormattedMessage
                      id="ui-plugin-inventory-templates.driveNewFieldsModal.drivedFieldsOptions.label"
                      defaultMessage="Drived fields options"
                    />
                  }
                  separator={false}
                  className={css.accContainer}
                >
                  <div style={{ padding: '0 30px' }}>{renderDrivedFields()}</div>
                </Accordion>
              )}
              {droppableProvided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
}

DrivedFieldsValues.propTypes = {
  fields: PropTypes.object,
  fieldData: PropTypes.object,
};

export default DrivedFieldsValues;
